import { merchantApi } from '../setup/setupMerchantApi';
import { AccountManager, AgreementStatusOnlyArray } from './types';

export const getAgreementStatusOnly = (merchantId: number): Promise<AgreementStatusOnlyArray> =>
  merchantApi
    .get(`/merchant/current/merchants/${merchantId}/agreements/status_only`)
    .then((res) => res.data);

export const getAccountManager = (merchantId: number): Promise<AccountManager> =>
  merchantApi
    .get(`/merchant/current/merchants/${merchantId}/contacts/account_manager`)
    .then((res) => res.data);
